import { required, minLength, maxLength, requiredIf } from 'vuelidate/lib/validators';
import { BModal } from 'bootstrap-vue';
import { Component, Inject, Ref, Prop, Watch } from 'vue-property-decorator';
import AlertService from '@/shared/alert/alert.service';
import { CatalogosApi } from '@conacyt/catalogos-client';
import SolicitudService from '@/entities/solicitud/solicitud.service';
import { Solicitud } from '@/shared/model/solicitud.model';
import { IHijos } from '@/shared/model/datosHijos.model';
import { CURP } from '@/shared/formatter/regex-utils';
import { TipoAccion } from '@/shared/model/enumerations/tipo-accion.model';
import ApeironComponent from '../commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { RenapoResourceApi } from '@conacyt/renapo-client';
import { Parentesco } from '@/shared/model/enumerations/parentesco';
import { TipoSolucion } from '@/shared/model/enumerations/tipo-solucion.model';
import { ICatalogoGenericoDto } from '@/shared/model/catalogoGenericoDto.model';
import { ICatalogoPaises } from '@/shared/model/catalogoPaises.model';
import { IInstitucionesMs } from '@/shared/model/seguimiento/instituciones-ms.model';
import { ICatalogoDto } from '@/shared/model/catalogoDto.model';
import { Filtro } from '@/shared/model/filtro.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import Utilidades from '@/shared/config/utilidades';

const VALIDATIONS = function () {
  return {
    personaCurp: {
      curp: {
        required,
        CURP,
      },
      curpPareja: {
        CURP,
      },
      nombres: {
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      apellidoPaterno: {
        minLength: minLength(3),
        maxLength: maxLength(30),
      },
      apellidoMaterno: {
        minLength: minLength(3),
        maxLength: maxLength(30),
      },
      genero: {
        maxLength: maxLength(20),
      },
      fechaNacimiento: {
        required,
      },
      paisNacimiento: {
        required,
      },
      parentesco: {
        required,
      },
      discapacidad: {},
      detalleDiscapacidad: {
        required: requiredIf(function () {
          return this.personaCurp.discapacidad === 'si';
        }),
      },
      fechaAdopcion: {
        required: requiredIf(function () {
          return this.esAdoptado;
        }),
      },
    },
  };
};

@Component({
  validations: VALIDATIONS,
})
export default class DatosHijosComponent extends ApeironComponent {
  @Inject('alertService') public alertService: () => AlertService;
  @Inject('solicitudService') private solicitudService: () => SolicitudService;
  @Inject('renapoApi') private renapoApi: () => RenapoResourceApi;
  @Inject('catalogosApi') private catalogosApi: () => CatalogosApi;

  @Ref('confirmacionModal')
  public readonly confirmacionModal: BModal;

  @Ref('registroModal')
  public readonly registroModal: BModal;

  @Ref('eliminaHijoModal')
  public readonly eliminaHijoModal: BModal;

  @Prop({ required: false })
  public solicitud: Solicitud;

  @Prop({ default: null })
  public required: boolean;

  @Prop({ required: true })
  public readonly solucion: Solucion;

  public isFetching = false;
  form = this.solicitudModel;

  public totalItems = 0;
  public isSearching = false;
  public mensajeCarga: string = null;
  public indicadorCargaShow = false;
  public accion: string = null;
  public tituloModal: string = null;
  public mensajeConfirmacion: string = null;
  public descripcionActividad: string = null;
  public datosHijos: IHijos[];
  public inputCURPHijo = '';
  public inputCURPPareja = '';
  public isEdit = false;
  public requiredString = '';
  public placeholderBuscador = this.$t('apeironGwApp.datosHijos.buscador-curp.placeHolder');
  public placeholderBuscadorPareja = this.$t('apeironGwApp.datosHijos.buscador-curp.placeHolderPareja');
  public parentescoOptions = [];
  public erroresCURP = '';
  public existenErrores = false;
  public existeCurpHijo = false;
  public existeCurpPareja = false;
  public solicitudId = '';
  public esAdoptado = false;
  public resultado: true | string = true;
  public fechaInicialValidacion: Date | null = null;
  public fechaFinalValidacion: Date | null = null;

  public catPaises: Array<ICatalogoGenericoDto> = [];
  public catInstituciones: Array<ICatalogoDto> = [];

  // Lista de paises que pertenecen a la Unión Europea
  private readonly paisesUnionEuropea: string[] = [
    'Alemania',
    'Austria',
    'Bélgica',
    'Bulgaria',
    'Chipre',
    'Croacia',
    'Dinamarca',
    'Eslovaquia',
    'Eslovenia',
    'España',
    'Estonia',
    'Finlandia',
    'Francia',
    'Grecia',
    'Hungría',
    'Irlanda',
    'Italia',
    'Letonia',
    'Lituania',
    'Luxemburgo',
    'Malta',
    'Países Bajos',
    'Polonia',
    'Portugal',
    'República Checa',
    'Rumanía',
    'Suecia',
    'Cuba',
  ];

  public personaCurp: IHijos = {
    curp: null,
    nombres: null,
    apellidoPaterno: null,
    apellidoMaterno: null,
    genero: null,
    fechaNacimiento: null,
    nacionalidad: null,
    parentesco: null,
    curpPareja: null,
    curpSolicitante: null,
    consecutivo: null,
    monto: null,
    divisa: null,
    paisNacimiento: null,
    discapacidad: null,
    detalleDiscapacidad: null,
    adoptado: null,
    fechaAdopcion: null,
  };

  private get solicitudModel() {
    return {
      solicitud: {
        datosHijos: [],
      },
    };
  }

  /**
   * Obtiene las opciones de discapacidad para ser utilizadas en componentes de selección.
   *
   * Cada opción contiene:
   * - `text`: Texto traducido mostrado al usuario.
   * - `value`: Valor interno asociado a la opción.
   *
   * Las traducciones se obtienen mediante la función `$t`, utilizando las claves:
   * - `apeironGwApp.datosHijos.buscador-curp.si`
   * - `apeironGwApp.datosHijos.buscador-curp.no`
   *
   * @returns {Array<{ text: string; value: string }>}
   * Arreglo de opciones con valores "si" y "no".
   */
  public get discapacidadOptions() {
    return [
      { text: this.$t('apeironGwApp.datosHijos.buscador-curp.si'), value: 'si' },
      { text: this.$t('apeironGwApp.datosHijos.buscador-curp.no'), value: 'no' },
    ];
  }

  public mounted() {
    this.parentescoOptions = Object.keys(Parentesco);
    this.initCatalogos();
  }

  private limpiaPersonaCurp() {
    this.personaCurp = {
      curp: null,
      nombres: null,
      apellidoPaterno: null,
      apellidoMaterno: null,
      genero: null,
      fechaNacimiento: null,
      nacionalidad: null,
      parentesco: null,
      curpPareja: null,
      curpSolicitante: null,
      consecutivo: null,
      monto: null,
      divisa: null,
      paisNacimiento: null,
      discapacidad: null,
      detalleDiscapacidad: null,
      adoptado: null,
      fechaAdopcion: null,
    };
    this.inputCURPHijo = '';
    this.inputCURPPareja = '';
    this.existenErrores = false;
    this.erroresCURP = '';
  }

  /**
   * Realiza la búsqueda, validación y carga de información del CURP del hijo.
   *
   * Este método ejecuta las siguientes operaciones:
   *
   * - Reinicia los estados internos del componente.
   * - Valida el formato del CURP del hijo ingresado.
   * - Verifica si el hijo ya existe dentro de la solicitud actual.
   * - Consulta al backend para validar si el CURP ya está registrado en otras solicitudes activas.
   * - Consulta los datos del CURP de en RENAPO.
   * - Llena automáticamente los datos del hijo en `personaCurp`.
   * - Normaliza y verifica los apellidos del hijo contra los del solicitante y,
   *   si existe un CURP de pareja, también contra la pareja.
   * - Muestra mensajes de error cuando una validación falla y detiene el flujo.
   *
   * Este método no retorna información directa, pero modifica estados internos como:
   * - `personaCurp`: Datos poblados desde RENAPO.
   * - `solicitudId`: ID de una solicitud existente donde ya esté registrado el CURP.
   * - `isSearching`: Bandera de estado durante la búsqueda.
   *
   * También maneja internamente los errores HTTP provenientes de servicios externos.
   *
   * @returns Una promesa 'Promise' que se resuelve cuando el proceso ha sido completado.
   */
  public async buscarCURP(): Promise<void> {
    this.resultado = true;
    this.resetEstados();
    try {
      if (!this.validarCURP(this.inputCURPHijo)) {
        this.mostrarError(this.$t('apeironGwApp.datosHijos.errores.curpHijo').toString());
        return;
      }

      const hijoDuplicado = this.solicitud.datosHijos?.some((hijo: any) => hijo.curp === this.inputCURPHijo);

      if (hijoDuplicado) {
        this.mostrarError(this.$t('apeironGwApp.datosHijos.errores.solicitudHijo').toString());
        return;
      }

      await this.validarCurpEnSolicitudesActivas();

      const renapoHijo = await this.renapoApi().getRenapoInternalUsingGET(this.inputCURPHijo);

      if (!renapoHijo?.data) {
        this.mostrarError('No se encontró el CURP del hijo en RENAPO');
        return;
      }

      const datosHijo = renapoHijo.data;

      this.personaCurp.curp = datosHijo.curp;
      this.personaCurp.nombres = datosHijo.nombres;
      this.personaCurp.apellidoPaterno = datosHijo.apellido1;
      this.personaCurp.apellidoMaterno = datosHijo.apellido2;
      this.personaCurp.genero = datosHijo.sexo;
      this.personaCurp.fechaNacimiento = datosHijo.fechNac;
      this.personaCurp.nacionalidad = datosHijo.nacionalidad;
      this.personaCurp.curpSolicitante = this.solicitud.solicitante.curp;
      this.personaCurp.paisNacimiento = datosHijo.nacionalidad === 'MEX' ? 'México' : undefined;
      this.personaCurp.discapacidad = 'no';

      const apellidosHijo = this.normalizarApellidos(datosHijo.apellido1, datosHijo.apellido2);

      const apellidosSolicitante = this.normalizarApellidos(
        this.solicitud.solicitante.apellidoPaterno,
        this.solicitud.solicitante.apellidoMaterno
      );

      if (this.inputCURPPareja) {
        if (!this.validarCURP(this.inputCURPPareja)) {
          this.mostrarError(this.$t('apeironGwApp.datosHijos.errores.curpPareja').toString());
          return;
        }

        const renapoPareja = await this.renapoApi().getRenapoInternalUsingGET(this.inputCURPPareja);

        if (!renapoPareja?.data) {
          return this.mostrarError('No se encontró el CURP de la pareja en RENAPO');
        }
        const datosPareja = renapoPareja.data;

        const apellidosPareja = this.normalizarApellidos(datosPareja.apellido1, datosPareja.apellido2);

        if (!this.esAdoptado) {
          this.resultado = this.validarApellidos(apellidosHijo, apellidosSolicitante, apellidosPareja);
          if (this.resultado !== true) {
            return this.mostrarError(this.resultado);
          }
        }

        this.personaCurp.curpPareja = this.inputCURPPareja;
      } else {
        if (!this.esAdoptado) {
          this.resultado = this.validarApellidos(apellidosHijo, apellidosSolicitante);
          if (this.resultado !== true) {
            return this.mostrarError(this.resultado);
          }
        }
      }
    } catch (err: any) {
      switch (err.response.status) {
        case 404:
          this.alertService().showError(this, err.response.data.detail);
          break;
        case 500:
          this.alertService().showError(this, this.$t('apeironGwApp.datosHijos.errores.servicios').toString());
          break;
        default:
          this.alertService().showHttpError(this, err.response);
      }
    } finally {
      this.isSearching = false;
    }
  }

  public permiteGuardar(): boolean {
    return this.resultado === true;
  }

  public handleAdoptadoChange() {
    this.limpiaPersonaCurp();
  }

  private async validarCurpEnSolicitudesActivas(): Promise<void> {
    const filtroSol = new Filtro();
    filtroSol.curpHijo = this.inputCURPHijo;
    filtroSol.cvuSolicitante = this.solicitud.solicitante?.cvu;
    filtroSol.estadoSolicitud = EstadoSolicitud.FORMALIZADA;

    const paginationQuery = {
      page: 0,
      size: 200,
      sort: 'asc.id',
      filter: filtroSol,
    };

    const solicitudes = await this.solicitudService().validaCurpSolicitudes(paginationQuery);

    if (solicitudes?.length) {
      const mostrarErrorSolicitud = (solicitud: any) => {
        this.solicitudId = solicitud.id;
        this.mostrarError(
          this.$t('apeironGwApp.datosHijos.errores.registroHijo', {
            solicitudId: solicitud.id,
            nombre: solicitud.solicitante.nombre,
            apellidoPaterno: solicitud.solicitante.apellidoPaterno,
            apellidoMaterno: solicitud.solicitante.apellidoMaterno,
            cvu: solicitud.solicitante.cvu,
          }).toString()
        );

        this.isSearching = false;
      };

      // Buscar solicitud activa
      const solicitudActiva = solicitudes.find(
        (s: any) => s.estado !== EstadoSolicitud.CANCELADA && s.estado !== EstadoSolicitud.FINALIZADA
      );

      if (solicitudActiva) {
        mostrarErrorSolicitud(solicitudActiva);
        return;
      }
    }
  }

  /**
   * Normaliza una lista de apellidos eliminando valores nulos, indefinidos o vacíos,
   * y estandarizando el formato (eliminando espacios y convirtiendo a mayúsculas).
   *
   * @param apellidos - Lista variable de apellidos a normalizar.
   * @returns Un arreglo de apellidos válidos, limpios y en mayúsculas.
   */
  private normalizarApellidos(...apellidos: (string | null | undefined)[]): string[] {
    return apellidos.filter(a => a && a.trim().length > 0).map(a => a!.trim().toUpperCase());
  }

  /**
   * Valida que los apellidos del hijo coincidan con los del solicitante
   * y opcionalmente con los de la pareja (si existe).
   *
   * - Si existe pareja, el hijo debe compartir al menos un apellido con cada uno.
   * - Si no existe pareja, debe compartir al menos un apellido con el solicitante.
   *
   * @param apellidosHijo - Apellidos normalizados del hijo.
   * @param apellidosSolicitante - Apellidos normalizados del solicitante.
   * @param apellidosPareja - (Opcional) Apellidos normalizados de la pareja.
   *
   * @returns `true` si la validación es correcta; de lo contrario,
   *          un `string` con el mensaje de error correspondiente.
   */
  private validarApellidos(apellidosHijo: string[], apellidosSolicitante: string[], apellidosPareja?: string[]): true | string {
    if (apellidosPareja && apellidosPareja.length > 0) {
      const coincideSolicitante = apellidosHijo.some(a => apellidosSolicitante.includes(a));
      const coincidePareja = apellidosHijo.some(a => apellidosPareja.includes(a));

      if (!coincideSolicitante || !coincidePareja) {
        return this.$t('apeironGwApp.datosHijos.errores.apellidosPadresHijo').toString();
      }
      return true;
    }

    const coincide = apellidosHijo.some(a => apellidosSolicitante.includes(a));

    if (!coincide) {
      return this.$t('apeironGwApp.datosHijos.errores.apellidosNoCoincidenSol', {
        apellidosSolicitante: apellidosSolicitante.join(' / '),
      }).toString();
    }

    return true;
  }

  /**
   * Reinicia los estados internos del componente relacionados con
   * la búsqueda y validación del CURP.
   *
   * Este método:
   * - Activa la bandera `isSearching`.
   * - Limpia mensajes de error.
   * - Reinicia indicadores de validación.
   */
  private resetEstados() {
    this.isSearching = true;
    this.resetEstadosGuardado();
  }

  /**
   * Reinicia los estados internos del componente relacionados con
   * el guardado del curp.
   *
   * Este método:
   * - Limpia mensajes de error.
   * - Reinicia indicadores de validación.
   */
  private resetEstadosGuardado() {
    this.existenErrores = false;
    this.erroresCURP = '';
  }

  /**
   * Muestra un mensaje de error y actualiza los estados internos relacionados
   * con la visualización de errores y el proceso de búsqueda.
   *
   * Este método:
   * - Establece el mensaje de error en `erroresCURP`.
   * - Activa la bandera `existenErrores`.
   * - Detiene el indicador de búsqueda (`isSearching`).
   *
   * @param msg - Mensaje de error que se mostrará al usuario.
   */
  private mostrarError(msg: string) {
    this.erroresCURP = msg;
    this.existenErrores = true;
    this.isSearching = false;
  }
  /**
   * Obtiene los accesos permitidos en las acciones configurados en la solucion
   */
  get accesosSolucion(): any {
    return this.grantService().accesos(this.solucion, this.solicitud);
  }

  /**
   * Obtiene bandera para indicar de solo lectura basado en la accion de Escribir
   */
  get readOnly(): boolean {
    return this.accesosSolucion.acciones.findIndex(accion => accion === TipoAccion.ESCRIBIR) === -1;
  }

  /**
   * Valida si debe mostrar texto de Rubros Extranjeros
   */
  get isrubrosExt(): boolean {
    return this.solicitud?.beca?.solucionSolicitud?.tipoSolucion === TipoSolucion.BECAS_EXTRANJERAS;
  }

  public get fields() {
    return [
      {
        key: 'curp',
        label: this.$t('apeironGwApp.datosHijos.grid.curp'),
        class: 'text-left',
        thStyle: { width: '5rem' },
      },
      {
        key: 'nombres',
        label: this.$t('apeironGwApp.datosHijos.grid.nombres'),
        class: 'text-left',
        thStyle: { width: '20rem' },
      },
      {
        key: 'apellidoPaterno',
        label: this.$t('apeironGwApp.datosHijos.grid.apellidoPaterno'),
        class: 'text-left',
        thStyle: { width: '20rem' },
      },
      {
        key: 'apellidoMaterno',
        label: this.$t('apeironGwApp.datosHijos.grid.apellidoMaterno'),
        class: 'text-left',
        thStyle: { width: '20rem' },
      },
      {
        key: 'fechaNacimiento',
        label: this.$t('apeironGwApp.datosHijos.grid.fechaNacimiento'),
        class: 'text-left',
        thStyle: { width: '10rem' },
      },
      {
        key: 'monto',
        label: this.$t('apeironGwApp.datosHijos.grid.monto'),
        class: 'text-left',
        thStyle: { width: '10rem' },
      },
      {
        key: 'divisa',
        label: this.$t('apeironGwApp.datosHijos.grid.divisa'),
        class: 'text-left',
        thStyle: { width: '10rem' },
      },
      {
        key: 'adoptado',
        label: this.$t('apeironGwApp.datosHijos.grid.adoptado'),
        class: 'text-left',
        thStyle: { width: '10rem' },
      },
      {
        key: 'discapacidad',
        label: this.$t('apeironGwApp.datosHijos.grid.discapacidad'),
        class: 'text-left',
        thStyle: { width: '10rem', display: 'none' },
        tdClass: 'd-none',
      },
      {
        key: 'detalleDiscapacidad',
        label: this.$t('apeironGwApp.datosHijos.grid.detalleDiscapacidad'),
        class: 'text-left',
        thStyle: { width: '10rem', display: 'none' },
        tdClass: 'd-none',
      },
    ];
  }

  //:::: EVENTOS :::::
  public edit() {
    this.isEdit = !this.isEdit;
    this.$v.form.$touch();
    this.$v.busquedaInstitucion.$touch();
  }

  /**
   * Prepara el registro para eliminar Hijo
   */
  public eliminarHijo(): void {
    if (this.solicitud.datosHijos.length > 0) {
      this.solicitud.datosHijos.pop();
      this.solicitudService()
        .update(this.solicitud)
        .then(() => {
          this.alertService().showSuccess(this, 'apeironGwApp.datosHijos.mensajes.ultimoHijo');
          this.eliminaHijoModal.hide();
        })
        .catch(error => {
          this.alertService().showHttpError(this, error.response);
        });
    }
  }

  /**
   * Valida y guarda un hijo en la solicitud.
   *
   * - Ejecuta validaciones de formulario y CURP.
   * - Verifica rango de fecha de nacimiento (excepto si tiene discapacidad).
   * - Asigna consecutivo, monto y divisa según tipo de apoyo.
   * - Agrega el hijo a la solicitud y la actualiza vía servicio.
   * - Muestra mensajes de éxito/error y controla el estado de carga.
   *
   * @returns {void}
   */
  public guardarHijo() {
    this.$v.personaCurp.$touch();
    this.resetEstadosGuardado();
    if (!this.solicitud.datosHijos) {
      this.solicitud.datosHijos = [];
    }

    if (!this.existenErrores && !this.validarCURP(this.personaCurp.curp)) {
      this.mostrarError(this.$t('apeironGwApp.datosHijos.errores.existenErrores').toString());
      return;
    }

    if (this.$v.personaCurp.$invalid) return;
    //Se agregan datos faltantes
    //Validación de rango de fechas
    const fechaNacimiento = this.parseFechaDDMMYYYY(this.personaCurp.fechaNacimiento);
    const fechaNacimientoValida =
      fechaNacimiento && this.fechaInicialValidacion && this.fechaFinalValidacion
        ? fechaNacimiento.getTime() >= this.fechaInicialValidacion.getTime() &&
          this.fechaFinalValidacion.getTime() >= fechaNacimiento.getTime()
        : false;

    const fechaAdopcionValida =
      this.personaCurp.fechaAdopcion && this.fechaInicialValidacion && this.fechaFinalValidacion
        ? this.parseFecha(this.personaCurp.fechaAdopcion).getTime() >= this.fechaInicialValidacion.getTime() &&
          this.parseFecha(this.personaCurp.fechaAdopcion).getTime() <= this.fechaFinalValidacion.getTime()
        : false;

    const utilidades = new Utilidades();
    const edad = utilidades.calcularEdadConFecha(fechaNacimiento || new Date());
    if (this.esAdoptado) {
      if (edad > 18) {
        this.mostrarError(this.$t('apeironGwApp.datosHijos.errores.edadAdopcion').toString());
        return;
      }

      if (!fechaAdopcionValida) {
        const mensaje = this.$t('apeironGwApp.datosHijos.errores.fechaAdopcionEntre', {
          fechaInicial: this.fechaInicialValidacion ? this.formatFechaDDMMYYYY(this.fechaInicialValidacion) : '',
          fechaFinal: this.fechaFinalValidacion ? this.formatFechaDDMMYYYY(this.fechaFinalValidacion) : '',
        }).toString();
        this.mostrarError(mensaje);
        return;
      }
    } else {
      if (this.personaCurp.discapacidad !== 'si' && !fechaNacimientoValida) {
        const mensaje = this.$t('apeironGwApp.datosHijos.errores.fechaNacimientoEntre', {
          fechaInicial: this.fechaInicialValidacion?.toLocaleDateString(),
          fechaFinal: this.fechaFinalValidacion?.toLocaleDateString(),
        }).toString();
        this.mostrarError(mensaje);
        return;
      }
    }

    this.personaCurp.parentesco = this.personaCurp.parentesco;
    this.personaCurp.paisNacimiento = this.personaCurp.paisNacimiento;
    this.personaCurp.consecutivo = this.solicitud.datosHijos.length + 1;
    if (this.isrubrosExt) {
      if (this.paisesUnionEuropea.includes(this.solicitud.beca.apoyo.pais.descripcion)) {
        this.personaCurp.monto = 2050;
        this.personaCurp.divisa = 'EUR';
      } else if (this.solicitud.beca.apoyo.pais.descripcion === 'Reino Unido') {
        this.personaCurp.monto = 1770;
        this.personaCurp.divisa = 'GBP';
      } else {
        this.personaCurp.monto = 2145;
        this.personaCurp.divisa = 'USD';
      }
    } else {
      this.personaCurp.monto = 43876.35;
      this.personaCurp.divisa = 'MXN';
    }
    this.personaCurp.adoptado = this.esAdoptado;
    this.solicitud.datosHijos.push(this.personaCurp);
    this.solicitud.nombreConvocatoria = this.solicitud.nombre;
    this.mensajeCarga = this.$t('indicadorCarga.guardando', {
      mensaje: this.$t('apeironGwApp.datosHijos.mensajes.actividad'),
    }).toString();
    this.indicadorCargaShow = true;
    this.solicitudService()
      .update(this.solicitud)
      .then(res => {
        this.alertService().showSuccess(this, this.$t('apeironGwApp.datosHijos.mensajes.guardadoExitoso').toString());
        this.cerrarModal();
      })
      .catch(error => {
        this.alertService().showHttpError(this, error.response);
      })
      .finally(() => {
        this.indicadorCargaShow = false;
      });
    this.limpiaPersonaCurp();
  }

  /**
   * Abre el modal para agregar un hijo.
   *
   * - Limpia los datos del formulario.
   * - Configura mensaje y estado de carga.
   * - Define la acción como "agregar".
   * - Muestra el modal y reinicia validaciones.
   *
   * @returns {void}
   */
  public abrirModalAgregar(): void {
    this.fechaInicialValidacion = this.solucion?.params?.fechaInicialNacimiento
      ? this.parseFecha(this.solucion.params.fechaInicialNacimiento)
      : this.parseFecha('2025-12-01');
    this.fechaFinalValidacion = this.solucion?.params?.fechaFinalNacimiento
      ? this.parseFecha(this.solucion.params.fechaFinalNacimiento)
      : this.parseFecha('2026-11-30');
    this.limpiaPersonaCurp();
    this.esAdoptado = false;
    this.personaCurp.fechaAdopcion = null;
    this.mensajeCarga = this.$t('indicadorCarga.cargando', {
      mensaje: this.$t('apeironGwApp.datosHijos.mensajes.pantalla'),
    }).toString();
    this.indicadorCargaShow = true;
    this.accion = 'A';
    this.tituloModal = this.$t('apeironGwApp.datosHijos.modal.title.agregar').toString();
    this.registroModal.show();
    this.indicadorCargaShow = false;
    this.$v.personaCurp.$reset();
  }

  public abrirModalEliminar() {
    this.eliminaHijoModal.show();
    this.accion = 'E';
    this.tituloModal = this.$t('apeironGwApp.datosHijos.modal.title.eliminar').toString();
  }

  public cerrarModal() {
    this.registroModal.hide();
    this.accion = null;
  }

  public abrirModalConfirmacion() {}

  public cerrarModalConfirmacion() {
    this.confirmacionModal.hide();
  }

  public cerrarModalConfirmacionEliminar() {
    this.eliminaHijoModal.hide();
  }

  public get buttonText() {
    switch (this.accion) {
      case 'A':
        return this.$t('apeironGwApp.cronogramaActividades.modal.boton.guardar');
      default:
        return null;
    }
  }

  public get buttonIcon() {
    switch (this.accion) {
      case 'A':
        return 'icon-guardar';
      default:
        return null;
    }
  }

  private validarFechas() {
    if ('E' === this.accion) {
      return true;
    }

    return true;
  }

  public initCatalogos() {
    this.getAllPaises().then((listaPaisTotal: ICatalogoPaises[]) => {
      this.catPaises = listaPaisTotal;
    });
  }

  onChangePais(clavePais: string) {
    this.getInstitucionesByPais(clavePais).then((listaInstTotal: IInstitucionesMs[]) => {
      this.catInstituciones = listaInstTotal;
    });
  }

  public aceptarConfirmacion() {
    switch (this.accion) {
      case 'A':
        this.guardarHijo();
        break;
      default:
        break;
    }
  }

  /**
   * Busca la solicitud.
   */
  public buscarSolucitud() {
    this.isFetching = true;
    this.solicitudService()
      .find(this.solicitud.id)
      .then(
        res => {
          this.form.solicitud = { ...res, ...JSON.parse(JSON.stringify(res)) };
          this.isFetching = false;
        },
        err => {
          this.isFetching = false;
        }
      );
  }

  /**
   * Consulta catálogo completo de paises
   *
   * @param pagina
   * @param catalogo en esquema {value: clavePais, text: nombre}
   * @returns
   */
  public async getAllPaises(pagina = 1, catalogo = []): Promise<any[]> {
    let total = 0;
    try {
      const res = await this.catalogosApi().getAllPaises(pagina, 100);

      if (res['headers']['x-total-pages'] && total == 0) {
        total = Number(res['headers']['x-total-pages']);
      }

      if (pagina === 1) {
        catalogo = res['data'];
      } else {
        catalogo = catalogo.concat(res['data']);
      }

      if (pagina >= total) {
        total = 0;
        catalogo.push({
          id: '65fa06c55810c04c72fd6db4',
          clave: 'MEX',
          nombre: 'México',
          nombreEsp: 'México',
          nombreIng: 'Mexico',
          divisa: 'MXN',
          nombreDivisa: '',
          rubros: {},
          version: '2025-01',
          activo: true,
          region: 'resto_mundo',
        });

        catalogo.sort((a, b) => a.nombreEsp.localeCompare(b.nombreEsp));
        return this.itemsAsOptions(catalogo, item => item.nombreEsp);
      }

      pagina++;
      return this.getAllPaises(pagina, catalogo);
    } catch (err) {
      if (err?.response?.data?.detail) {
        this.alertService().showError(this, err.response.data.detail);
      } else {
        this.alertService().showError(this, this.$t('error.internalServerError').toString());
      }
      return [];
    }
  }

  /**
   * Consulta catálogo completo de instituciones de un pais
   *
   * @param clavePais
   * @param pagina
   * @param catalogo en esquema {value: id, text: nombre}
   * @returns
   */
  public async getInstitucionesByPais(clavePais: string, pagina = 1, catalogo = []): Promise<any[]> {
    let total = 0;
    try {
      const res = await this.catalogosApi().getInstitucionesByPais(clavePais, pagina, 100);

      if (res['headers']['x-total-pages'] && total == 0) {
        total = Number(res['headers']['x-total-pages']);
      }

      if (pagina === 1) {
        catalogo = res['data'];
      } else {
        catalogo = catalogo.concat(res['data']);
      }

      if (pagina >= total) {
        total = 0;
        return this.itemsAsOptions(catalogo, item => item.id);
      }

      pagina++;
      return await this.getInstitucionesByPais(clavePais, pagina, catalogo);
    } catch (err) {
      if (err?.response?.data?.detail) {
        this.alertService().showError(this, err.response.data.detail);
      } else {
        this.alertService().showError(this, this.$t('error.internalServerError').toString());
      }
      return [];
    }
  }

  /**
   * Convierte listado de opciones a un esquema {value,text} para utilizar en componentes de
   * selección.
   * El value puede ser determinado desde la llamada al método para poder asignar de forma dinámica
   * un objeto o atributo deseado
   *
   * @param items listado de opciones
   * @param determinaValue método que determina el valor a utilizar
   * @returns listo en esquema {value,text}
   */
  itemsAsOptions(items: any[], determinaValue: (item: any) => any): any[] {
    return items.map(item => {
      return {
        value: determinaValue(item),
        text: item.nombre,
        disabled: false,
      };
    });
  }

  public parseFechaDDMMYYYY(fechaStr: string): Date {
    const [dia, mes, anio] = fechaStr.split('/').map(Number);
    return new Date(anio, mes - 1, dia); // mes inicia en 0
  }

  public parseFecha(fechaStr: string): Date {
    const [year, month, day] = fechaStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  public formatFechaDDMMYYYY(fecha: Date): string {
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const anio = fecha.getFullYear().toString();
    return `${dia}/${mes}/${anio}`;
  }

  /**
  *
  * | Sección                | Significado                           |         |       |                      |
    | ---------------------- | ------------------------------------- | ------- | ----- | -------------------- |
    | `[A-Z]{1}`             | Inicial del primer apellido           |         |       |                      |
    | `[AEIOUX]{1}`           | Primera vocal interna                 |         |       |                      |
    | `[A-Z]{2}`             | Inicial del segundo apellido y nombre |         |       |                      |
    | `\d{2}`                | Año de nacimiento                     |         |       |                      |
    | `(0[1-9]               | 1[0-2])`                              | Mes     |       |                      |
    | `(0[1-9]               | [12]\d                                | 3[01])` | Día   |                      |
    | `[HM]`                 | Sexo                                  |         |       |                      |
    | `(AS                   | BC                                    | BS      | ...)` | Estado de nacimiento |
    | `[B-DF-HJ-NP-TV-Z]{3}` | Consonantes internas                  |         |       |                      |
    | `[0-9A-Z]`             | Dígito diferenciador (homonimia)      |         |       |                      |
    | `\d`                   | Dígito verificador                    |         |       |                      |
   * @param curp CURP a validar
   * @returns Retorna true si el CURP cumple con el patrón, de lo contrario retorna false
   */
  private validarCURP(curp: string): boolean {
    const regexCURP =
      /^[A-Z]{1}[AEIOUX]{1}[A-Z]{2}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[HM](AS|BC|BS|CC|CL|CM|CS|CH|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]\d$/;
    return regexCURP.test(curp);
  }

  /**
   * Observa cambios en el campo `discapacidad`.
   *
   * - Si el valor es "no", limpia el detalle de discapacidad
   *   y reinicia su validación.
   *
   * @param {string} valor Valor actual de discapacidad.
   * @returns {void}
   */
  @Watch('personaCurp.discapacidad')
  onDiscapacidadChange(valor: string) {
    if (valor === 'no') {
      this.personaCurp.detalleDiscapacidad = '';
      this.$v.personaCurp.detalleDiscapacidad.$reset();
    }
  }
}
